import TranslationsTabs from '@rd-web-markets/market/dist/translations/TranslationsTabs';
import React from 'react';
import { Breadcrumb, Card, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import BreadcrumbsPortal from '@rd-web-markets/shared/dist/util/BreadcrumbsPortal';
import MasterSidebar from '@rd-web-markets/shared/dist/util/MasterSidebar';
import { USE_V2_DESIGN } from '@rd-web-markets/market/dist/constants';

const TranslationsPage = ({ accountType }) => {
  const { t } = useTranslation();
  const isV2 = USE_V2_DESIGN;

  return (
    <>
      {!isV2 && <MasterSidebar accountType={accountType} currentPage='translations' />}
      <BreadcrumbsPortal>
        <Breadcrumb>
          <Breadcrumb.Item linkAs={Link} linkProps={{to: '/admin'}}>{t('home')}</Breadcrumb.Item>
          <Breadcrumb.Item active>Translations</Breadcrumb.Item>
        </Breadcrumb>
      </BreadcrumbsPortal>
      <Row className='justify-content-center mx-0 mt-4'>
        <Col md={isV2 ? 10 : 12}>
          <Card>
            <Card.Body>
              <TranslationsTabs />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default TranslationsPage;
